import { gql } from '@apollo/client';
import { useQueryPromise } from '@starryui10/hooks/useQueryPromise';

const EntrySearch = gql`
    query AllResident($filter: [ResidentFilterInput]) {
        allResident(filter: $filter, limit: 100, sort: { field: NAME_LAST, order: ASC }) {
            nodes {
                id
                nameFirst
                nameLast
                iD1
                iD2
                iD3
                iD4
                iD5
                entryStatus {
                    abbreviation
                }
                categoryID
            }
        }
    }
`;

interface IAllResidentResults {
    allResident: {
        nodes: {
            id: string;
            nameFirst: string;
            nameLast: string;
            iD1: string;
            iD2: string;
            iD3: string;
            iD4: string;
            iD5: string;
            entryStatus: {
                abbreviation: string;
            };
            categoryID: string;
        }[];
    };
}

export interface IResidentSearchFilter {
    _Operator: 'AND' | 'OR';
    entryStatus?: { eq: string };
}

interface IEntrySearchVars {
    filter: IResidentSearchFilter[];
}

export const useResidentData = () => useQueryPromise<IAllResidentResults, IEntrySearchVars>(EntrySearch);
